import React, { FC } from "react";
//#region components
import WintSalaryReportTable from "./wintSalaryReportTable";
import { useGrossSalaryChangeContext } from "../context/useGrossSalaryChangeContext";
//#endregion

const GrossSalaryChangePreview: FC = () => {
  const { personData: data, loading } = useGrossSalaryChangeContext();

  return (
    <WintSalaryReportTable
      rows={data ? [data] : []}
      loading={loading}
      hiddenColumns={["state", "salaryYearMonth"]}
      hideMoreActionsButton
      hidePagination
      expandFirstRowByDefault
      disableUserLink
    />
  );
};

export default GrossSalaryChangePreview;
